//
//
//
//
//
//
//
//
//
//
//

import RbHeaderBaseProductSlide from '@/elements/header/product-slide/base-product-slide.vue'

export default {
  name: 'rb-header-product-slide',
  extends: RbHeaderBaseProductSlide,
  props: {
    analytics: {
      type: String,
      default: '',
    },
  },
  computed: {
    getDataElementId() {
      return this.analyticsElementId || this.analytics
    },
  },
}
